import '@/global/plugins/element';
import '@/global/plugins/echarts';
import '@/global/assets/theme/index.scss';

import Vue from 'vue';
import ElementUp from 'element-up'
import App from '@/global/views/App.vue';
import router from './router';
import store from './store';

import VeLine from 'v-charts/lib/line.common';
Vue.component(VeLine.name, VeLine);

Vue.use(ElementUp)
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  components: { App },
  // template: '<App platform="ad-user" />',
  router,
  store
}).$mount('#app');
